<template>
  <div class="container">
    <p>
      Administra tus colas y asigna usuarios a ellas. Podrás enrutar interacciones de tus contactos
      a colas específicas.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>
    <queues-table-controls @update="handleSearch" />
    <queues-table :loading="loading" @update="handleSearch" />
  </div>
</template>

<script setup>
import { reactive, watch, provide, ref } from "vue";
import { useStore } from "vuex";
import _ from "lodash";

import QueuesTable from "@/app/queues/components/tables/QueuesTable.vue";
import QueuesTableControls from "@/app/queues/components/tables/QueuesTableControls.vue";

const store = useStore();

store.dispatch("fetchAllProfiles");
const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/colas-1/`;

const loading = ref(false);
const filters = reactive({
  search: "",
  portfolio: 0,
});

provide("filters", filters);

const handleSearch = async () => {
  loading.value = true;

  await store.dispatch("fetchAllQueues", filters);

  loading.value = false;
};

watch(
  filters,
  _.debounce(() => handleSearch(), 500)
);
</script>

<style lang="sass" scoped>
.container
  padding: 12px 20px

.controls
  margin-bottom: 8px
</style>
